import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isCollapsed: false,
    selectedLeftNavItem: 'explorer',
};

const leftNavSlice = createSlice({
    name: 'leftNav',
    initialState,
    reducers: {
        toggleLeftNav: (state) => {
            state.isCollapsed = !state.isCollapsed;
        },
        updateLeftNavItem: (state, action) => {
            state.selectedLeftNavItem = action.payload;
        },
    },
});

export default leftNavSlice.reducer;

export const {
    toggleLeftNav,
    updateLeftNavItem,
} = leftNavSlice.actions;